import { Component, OnInit, inject } from '@angular/core';
import { NavigationService } from '../../../core/services/navigation.service';
import { LoginAttemptStatus } from '../../../core/enums/login-attempt-status.enum';
import { AuthenticationService, LoginAttemptResult } from '../../../core/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
    selector: 'app-saml',
    templateUrl: './saml.component.html',
    styleUrls: ['./saml.component.scss'],
    imports: []
})
export class SamlComponent implements OnInit {
  private authService = inject(AuthenticationService);
  private navigationService = inject(NavigationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  loginMessage = null;
  loginStatus = null;
  loginStatuses = LoginAttemptStatus;

  ngOnInit() {
    const queryParams = this.route.snapshot.queryParams;
    const code = queryParams['code'];

    if (!code) {
      this.router.navigate(['/login'], { replaceUrl: true });
    }

    this.authService.loginFromCode(code).subscribe((loginAttemptResult: LoginAttemptResult) => {
      this.loginMessage = loginAttemptResult.data;
      this.loginStatus = loginAttemptResult.status;
    });
  }

}
